import earnMoreIcon from '../../../../images/Icons/earn-more-icon.svg';
import electricityIcon from '../../../../images/Icons/electricity-icon.svg';
import safetyIcon from '../../../../images/Icons/safety-icon.svg';
import greenIcon from '../../../../images/Icons/green-icon.svg';

const cardContentEv = [
  {
    icon: earnMoreIcon,
    title: 'Earn More',
    text:
      'Ridesharing apps offer incentives when you drive a zero emission vehicle.'
  },
  {
    icon: safetyIcon,
    title: 'Safety',
    text:
      'Autzu EV vehicles are top rated for safety in the US and Europe.'
  },
  {
    icon: greenIcon,
    title: 'Zero Emissions',
    text:
      'Reduce your carbon footprint and be a part of the future by driving with Autzu EV.'
  },
  {
    icon: electricityIcon,
    title: 'Electric is cheaper than gas',
    text: 'Save on gas costs with lower electric charging costs.'
  }
];

export default cardContentEv;



// WEBPACK FOOTER //
// ./src/components/Static/TorontoFleets/AutzuEV/CardContentEv.js